export default __webpack_public_path__ + "aae3a19eb777f35e221464586cd6ba29.gif";